import { EnvVariablesModule } from "@pharaday/env";
import { Container } from "inversify";
import "reflect-metadata";

export const DockyardCentralContainer = new Container({ defaultScope: "Singleton" });
DockyardCentralContainer.load(EnvVariablesModule);
